import { useEffect } from 'react';
import { startServiceWorkerRuntime } from '@/shared/lib/pwa/runtime';

export function ServiceWorkerRuntimeEffect() {
  useEffect(() => {
    const stopServiceWorkerRuntime = startServiceWorkerRuntime();

    return () => {
      stopServiceWorkerRuntime();
    };
  }, []);

  return null;
}
